import { render, staticRenderFns } from "./EducationGraph.vue?vue&type=template&id=68922f16&scoped=true"
import script from "./EducationGraph.vue?vue&type=script&lang=js"
export * from "./EducationGraph.vue?vue&type=script&lang=js"
import style0 from "./EducationGraph.vue?vue&type=style&index=0&id=68922f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68922f16",
  null
  
)

export default component.exports